/*
Aditya 09/20/2022 2698966688 Integrated UDW lookup in Search
Suresh 09/20/2022 2698966688 Autocomplete dropdown Alignments
Rajesh 09/30/2022 2698966688 fixed search any UDW lookup search changes
Rajesh 10/01/2022 2698966688 fixed bugs in UDW
Ashraf 10/01/2022 2698966688 fixed custom window bugs
Ashraf 10/03/2022 2698966688 fixed placeholder for udw search text
Raghuarun 10/12/2022 2698966688 Patient Search Dollar Symbol alignment Fixed
Raghuarun 11/10/2022 2698966688 Dashboard Card and button alignments
Sai Maheshwar 11/11/2022 3031689933  integrated locked process
Gummala Prakash 11/17/2022 3031593925 Fixed Button Enahancements and Alignments
Raghu 02/27/2023 3031593925 button alignments
Phaneendra 06/05/2023 3031593925 Fixed pagination page break issue
Guru Prasad 06/23/1013 3031593925 Added Locked user name in the toast message
Guru Prasad 06/23/1013 3031593925 Changed toast message

*/

import React, { useState, useContext, useEffect } from 'react';
import { Button, InputAdornment, TextField } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import { Controller } from 'react-hook-form';
import SettingsDialog from './SettingsDialog';
import SelectTabContextProvider from '../../components/SelectTabContext/SelectTabContext';
import SearchForm from './SearchForm';
import DashboardTable from './DashboardTable';
import AdvanceSearchTable from './AdvanceSearchTable';
import { makeStyles, FormControl } from '@material-ui/core';
// import settingsIcon from "../../assets/images/invoice1.svg";
import { postUDWlookupData } from '../../redux/reducers/UDW/UDWlookup';
import SettingsIcon from '@material-ui/icons/Settings';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { SsnMaskCustom } from '../../util/SsnMaskFormat';
import inputStyles from '../../components/InputStyles';
import DateFnsUtils from '@date-io/date-fns';
import { Currency, PhoneMaskCustom } from '../../util/Currency';
import { getFormatDate } from '../../util/dateHelper';
import formatPhoneNumber from '../../util/PhoneFormat';
import { NumberFormatter } from '../../components/UserDefinedForm/AppTextInputComponents';
import { ErrorSnackbar } from '../../components/CustomSnackBar';
import { fetchAccountSummary } from '../../redux/reducers/AccountSummary';
import GuiAutoComplete from '../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../components/FormComponents/GuiTextField';
import { ReactComponent as EmptySearchIcon } from '../../assets/images/emptySearchIcon.svg';
import NoResultsMessage from '../EmptyResultsWindow/EmptyWindowMessage';

const useStyles = makeStyles((theme) => ({
  lookupFields: {
    borderRadius: '6px',
    backgroundColor: 'white',
    '& .MuiAutocomplete-input': {
      padding: '10.5px 10.5px !important',
    },
  },
  labelName: {
    '& .MuiOutlinedInput-input': {
      fontSize: '13px',
    },
  },
  amountLabel: {
    '& .MuiOutlinedInput-inputAdornedStart': {
      paddingLeft: '0 !important',
    },
  },
  inputLabel: {
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      fontWeight: '600',
    },
  },
  dollar: {
    marginBottom: '20px',
  },
  DateField: {
    position: 'relative',
    '& .MuiFormHelperText-root.Mui-error': {
      position: 'absolute',
      top: '40px',
      color: 'white !important',
    },
  },
}));

export default function DashboardSearch({ data }) {
  const classes = useStyles();
  const classes1 = inputStyles();
  const [searchedData, setSearchedData] = useState([]);
  const [submit, setSubmit] = useState(false);
  const [searchedResults, setSearchResults] = useState(0);
  const [advanceSearchData, setAdvanceSearchData] = useState(false);
  const { searchData } = useSelector(({ search }) => search);
  const { udwlookupData, dropDownData } = useSelector(({ udwLookup }) => udwLookup);
  const [lookupSearch, setLookupSearch] = useState(false);
  const [accountSearched, setAccountSearched] = useState(false);
  const { search, searchAny, setIsLookupUDWdata, setSummary } =
    useContext(SelectTabContextProvider);
  const [clear, setClear] = useState(false);
  const [udwData, setUdwData] = useState('');
  const [submitValue, setSubmitValue] = useState('');
  const { lockedAccountStatus, lockedAccountNumber } = useSelector(
    ({ accountSummary }) => accountSummary,
  );

  const dispatch = useDispatch();
  useEffect(() => {
    if (search) {
      setSearchedData(searchData);
    }
  }, [searchData]);

  useEffect(() => {
    if (udwlookupData?.length > 0) {
      setSearchedData(udwlookupData);
    }
  }, [udwlookupData]);
  // useEffect(() => {
  //  dispatch(fetchUdwDropdown());
  // }, []);
  // useEffect(() => {
  //   if (lockedAccountStatus) {
  //     setTimeout(() => {
  //       dispatch(resetLockAccountStatus());
  //     }, 7000);
  //   }
  // }, [lockedAccountStatus]);

  useEffect(() => {
    setSummary(true);
  }, []);

  useEffect(() => {
    if (searchedData.length === 1) {
      const accNumber = searchedData[0]?.seedNumber
        ? searchedData[0].seedNumber
        : searchedData[0].accountNumber
          ? searchedData[0].accountNumber
          : '';
      dispatch(fetchAccountSummary(accNumber));
    }
  }, [searchedData]);

  useEffect(() => {
    if (searchedData?.length > 0 || searchedData?.resultObject?.length > 0) {
      setSearch(false);
    }
  }, [searchedData]);
  const [open, setOpen] = useState(false);
  const [AdvanceSearch, setSearch] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const initialValues = {
    data: '',
    lookup: '',
    date: null,
    ssn: '',
    phone: '',
    amount: '',
    number: '',
  };
  const { register, handleSubmit, control, setValue } = useForm({
    mode: 'onChange',
    defaultValues: initialValues,
  });
  // const handleSearch = () => {
  //   setSearch(!AdvanceSearch);
  // };
  const handleClose = () => {
    setOpen(false);
    // setSearch(false);
  };
  const onSubmit = (data) => {
    setLookupSearch(true);
    dispatch(
      postUDWlookupData({ data: submitValue ? submitValue : '', lookup: data?.lookup?.lookup }),
    );
    // reset(initialValues);
  };
  useEffect(() => {
    if (searchAny?.key === 'udwLookup') {
      setIsLookupUDWdata(true);
    } else {
      setIsLookupUDWdata(false);
      setLookupSearch(false);
    }
  }, [searchAny]);
  const udwType = ['text', 'Text', 'string', 'Print', 'Email', 'Reference', 'dropdown'];
  const lockUser = useSelector((state) => state?.accountSummary?.lockUser);
  return (
    <>
      <div className="dash-board">
        <div className={`rounded ${classes1.cardBordernoneStyles}`}>
          <div className="row align-items-center">
            <div className="col-sm-12 col-md-6">
              <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
                <div className="form-row align-items-cemter">
                  {searchAny?.key === 'udwLookup' && (
                    <div className="col-sm-5">
                      <Controller
                        render={(props) => (
                          <GuiAutoComplete
                            classes={{
                              popper: classes.dropDown,
                              option: classes.option,
                            }}
                            {...props}
                            id="lookup"
                            options={dropDownData?.length > 0 ? dropDownData : []}
                            size="small"
                            getOptionDisabled={(option) => option?.fieldType === null}
                            getOptionLabel={(option) => {
                              return option && option?.lookup
                                ? option?.lookup
                                : option?.value === null
                                  ? option?.lookup
                                  : '';
                            }}
                            renderInput={(params) => (
                              <GuiTextField
                                className={` ${classes.lookupFields}`}
                                {...params}
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                // label="State"
                                name="lookup"
                                placeholder="Select Lookup"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: 'off',
                                }}
                              />
                            )}
                            onChange={(_, data) => {
                              props.onChange(data);
                              setUdwData(data?.fieldType);
                            }}
                          />
                        )}
                        name="lookup"
                        control={control}
                      />
                    </div>
                  )}
                  {udwType.includes(udwData) ? (
                    <div className="col-sm-4 ">
                      <TextField
                        className={`${classes.lookupFields}`}
                        placeholder={`${
                          udwData?.toLowerCase() === 'email' ? 'Enter Email' : 'Enter Text'
                        }`}
                        margin="dense"
                        name="data"
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        fullWidth
                        inputRef={register}
                        onChange={(e) => {
                          setSubmitValue(e.target.value);
                        }}
                      />
                    </div>
                  ) : udwData === 'Date' || udwData === 'date' ? (
                    <div className="col-sm-4">
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Controller
                          render={({ value, onChange }) => (
                            <KeyboardDatePicker
                              className={`${classes.lookupFields} ${classes.DateField}`}
                              orientation="portrait"
                              format="MM/dd/yyyy"
                              placeholder="MM/DD/YYYY"
                              fullWidth
                              value={value}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputVariant="outlined"
                              onChange={(date) => {
                                onChange(date);
                                setSubmitValue(getFormatDate(date));
                              }}
                              autoOk
                              margin="dense"
                            />
                          )}
                          control={control}
                          name="date"
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                  ) : udwData === 'SSN' ? (
                    <div className="col-sm-4">
                      <FormControl variant="outlined" fullWidth>
                        <Controller
                          render={({ value, onChange }) => (
                            <TextField
                              className={` ${classes.lookupFields}`}
                              placeholder="Enter SSN"
                              margin="dense"
                              name="ssn"
                              variant="outlined"
                              value={value}
                              onChange={(e) => {
                                onChange(e);
                                setSubmitValue(e.target.value);
                              }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              InputProps={{
                                inputComponent: SsnMaskCustom,
                              }}
                              fullWidth
                            />
                          )}
                          control={control}
                          name="ssn"
                        />
                      </FormControl>
                    </div>
                  ) : udwData === 'Phone' ? (
                    <div className="col-sm-4">
                      <FormControl variant="outlined" fullWidth>
                        <Controller
                          render={({ value, onChange }) => (
                            <TextField
                              className={`${classes.lookupFields}`}
                              placeholder={`Enter Phone`}
                              margin="dense"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              value={value}
                              onChange={(e) => {
                                onChange(e.target.value);
                                setSubmitValue(formatPhoneNumber(e.target.value));
                              }}
                              InputProps={{
                                inputComponent: PhoneMaskCustom,
                              }}
                              fullWidth
                            />
                          )}
                          control={control}
                          name="phone"
                        />
                      </FormControl>
                    </div>
                  ) : udwData === 'Amount' ? (
                    <div className="col-sm-4">
                      <FormControl variant="outlined" fullWidth>
                        <Controller
                          render={({ value, onChange }) => (
                            <TextField
                              margin="dense"
                              variant="outlined"
                              className={` ${classes.lookupFields}  ${classes.amountLabel} `}
                              placeholder=" Enter Amount"
                              onKeyPress={(event) => {
                                if (!/\d|[.]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              value={value}
                              InputProps={{
                                inputComponent: Currency,
                                startAdornment: (
                                  <InputAdornment position="start" className={`${classes.dollar}`}>
                                    $
                                  </InputAdornment>
                                ),
                              }}
                              onChange={(e) => {
                                onChange(e.target.value);
                                setValue(name, e.target.value);
                                setSubmitValue(e.target.value);
                              }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              fullWidth
                            />
                          )}
                          control={control}
                          name="amount"
                        />
                      </FormControl>
                    </div>
                  ) : udwData === 'Number' ? (
                    <div className="col-sm-4">
                      <Controller
                        render={({ value, onChange }) => (
                          <TextField
                            margin="dense"
                            variant="outlined"
                            className={` ${classes.lookupFields} ${classes.labelName} ${classes.inputLabel}`}
                            placeholder={`Enter Number`}
                            value={value}
                            InputProps={{
                              inputComponent: NumberFormatter,
                            }}
                            onChange={(e) => {
                              onChange(e.target.value);
                              setValue(name, e.target.value);
                              setSubmitValue(e.target.value);
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            fullWidth
                          />
                        )}
                        control={control}
                        name="number"
                      />
                    </div>
                  ) : (
                    ''
                  )}
                  {searchAny?.key === 'udwLookup' && (
                    <div className="col-sm-3">
                      <Button
                        variant="contained"
                        className={`themeing-buttons mx-1 mt-1 ${classes1.buttonRoot}`}
                        type="submit"
                        onClick={() => setSearch(false)}
                      >
                        <span>Search</span>
                      </Button>
                    </div>
                  )}
                </div>
              </form>
            </div>
            <div className="col-sm-12 col-md-6 text-right mb-3 new-standard-textfields">
              {/* {!AdvanceSearch && (
                <Button
                  variant="outlined"
                  size="large"
                  className={`mr-2 search-btn ${classes1.buttonRoot}`}
                  onClick={() => handleSearch()}
                >
                  {!AdvanceSearch ? 'Advanced Search' : 'Cancel'}
                </Button>
              )} */}
              <Button
                variant="outlined"
                size="large"
                className={`ml-2 search-btn ${classes1.buttonRoot}`}
                onClick={handleClickOpen}
              >
                <SettingsIcon style={{ marginRight: '5px' }} />
                Settings
              </Button>
            </div>
          </div>

          {AdvanceSearch && (
            <div>
              <SearchForm
                setSearchedData={setSearchedData}
                setAdvanceSearchData={setAdvanceSearchData}
                setSubmit={setSubmit}
                clear={clear}
                setClear={setClear}
                setLookupSearch={setLookupSearch}
              />
            </div>
          )}
          <div className="d-flex my-2 align-items-center justify-content-end new-standard-textfields">
            <SettingsDialog open={open} handleModalClose={handleClose} />
            {/* {AdvanceSearch && (
              <div>
                <Button
                  variant="outlined"
                  className={`mx-1 reset-btn ${classes.buttonRoot}`}
                  onClick={() => {
                    handleSearch();
                    AdvanceSearch && setLookupSearch(false);
                  }}
                >
                  {!AdvanceSearch ? 'Advanced Search' : 'Cancel'}
                </Button>
              </div>
            )} */}
          </div>

          {!AdvanceSearch || search ? (
            <>
              <DashboardTable
                searchedData={searchedData}
                lookupSearch={lookupSearch}
                submit={submit}
                setSubmit={setSubmit}
                searchedResults={searchedResults}
                setSearchedData={setSearchedData}
                setSearchResults={setSearchResults}
                accountSearched={accountSearched}
                setAccountSearched={setAccountSearched}
                setAdvanceSearchData={setAdvanceSearchData}
              />
              {accountSearched && searchedResults < 1 && (
                <NoResultsMessage
                  title="No results matched your search"
                  description="You may want to confirm you are searching within the correct
                  category and adjust to find what you are looking for."
                  icon={EmptySearchIcon}
                />
              )}
            </>
          ) : (
            <AdvanceSearchTable
              searchedData={searchedData}
              submit={submit}
              setSubmit={setSubmit}
              clear={clear}
              setClear={setClear}
              advancedSearchData={advanceSearchData}
              setSearchResults={setSearchResults}
            />
          )}
          {lockedAccountStatus && (
            <ErrorSnackbar
              errorMsg={`Account ${lockedAccountNumber} has been locked by ${lockUser}, please try again later.`}
            />
          )}
        </div>
      </div>
    </>
  );
}
